import React from 'react';

export function AssemblyDetails() {
  return <div>AssemblyDetails</div>;
}
